export const LOCATIONS = [
  {
    id: 1,
    flag: "🇵🇭",
    country: "Philippines",
    description: "The Philippines is a leading destination for offshore staffing, particularly known for its strong English proficiency and customer service excellence. The country has a large, educated workforce with a cultural affinity for Western business practices.",
    city: "Manila",
    timezone: "GMT+8 (Philippine Time)",
    businessHours: "7:00 AM - 4:00 PM PHT (Monday - Friday)",
    languages: "English, Filipino (Tagalog)",
    currency: "Philippine Peso (PHP)",
    dialingCode: "+63",
    educationLevel: "High - 95% literacy rate, strong tertiary education",
    internetSpeed: "Average - Improving rapidly with fiber rollout",
    keyIndustries: ["Business Process Outsourcing (BPO)", "IT & Software Development", "Customer Service", "+3"],
    population: "113 million",
    salaryRange: "$400 - $1,200 USD/month",
    keyAdvantages: [
      "Neutral English accent, easily understood globally",
      "Large talent pool across multiple industries",
      "Strong government support for BPO industry",
      "Cultural compatibility with Western markets",
      "Cost-effective without compromising quality",
      "Flexible working hours, willing to work night shifts",
    ],
    attributes: [
      "Strong work ethic and loyalty to employers",
      "Excellent communication skills in English",
      "Strong government support for BPO industry",
      "Adaptable to Western business culture",
      "Highly hospitable and service-oriented",
      "Values relationships and teamwork",
    ],
    importantConsiderations: [
      "Internet infrastructure varies by location",
      "Typhoon season (June-November) may cause disruptions",
      "May require investment in equipment/connectivity",
      "High competition for top talent",
    ],
    recommendedRoles: [
      {
        title: "Accounts payable and receivable clerks",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Accounts clerks",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Arrears and debt recovery officers",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Audit assistants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Audit support staff",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Bookkeepers",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Chief financial officer",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Client billing and accounts receivable",
        fit: "Viable",
        description: "Viable - works with training/process guardrails",
        difficulty: 3
      },
      {
        title: "Financial analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "General accountants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Management reporting analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Payroll and rostering support",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Tax preparation assistants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Trust accountants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Trust account administrators",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
    ]
  },
  {
    id: 2,
    flag: "🇱🇰",
    country: "Sri Lanka",
    city: "Colombo",
    timezone: "GMT+5:30 (Sri Lanka Time)",
    population: "22 million",
    description: "Sri Lanka offers a highly educated, English-speaking workforce with strong technical capabilities. Known as the \"Pearl of the Indian Ocean,\" the country has emerged as a competitive destination for IT services, creative industries, and professional services.",
    businessHours: "9:00 AM - 5:30 PM SLST (Monday - Friday)",
    languages: "Sinhala, Tamil, English",
    currency: "Sri Lankan Rupee (LKR)",
    dialingCode: "+94",
    educationLevel: "Very High - 93% literacy rate, strong STEM education",
    internetSpeed: "Good - Reliable fiber optic infrastructure",
    keyIndustries: ["Information Technology", "Software Development", "Graphic Design & Creative", "+3"],
    salaryRange: "$300 - $900 USD/month",
    keyAdvantages: [
      "Highly educated workforce with STEM focus",
      "Strong work ethic and reliability",
      "Stable internet infrastructure",
      "Competitive pricing for technical roles",
      "Good English proficiency in professional sector",
      "Creative and innovative thinking",
    ],
    attributes: [
      "Highly educated workforce with technical skills",
      "Professional and detail-oriented approach",
      "Strong government support for BPO industry",
      "Strong analytical and problem-solving abilities",
      "Culturally diverse and adaptable",
      "Cost-effective without compromising quality",
      "Buddhist work ethics emphasize quality and mindfulness",
    ],
    importantConsiderations: [
      "Smaller talent pool compared to larger markets",
      "Accent may be noticeable in voice-heavy roles",
      "Recent economic challenges affecting stability",
      "Time zone difference with Western markets",
      "May require cultural adaptation training",
    ],
    recommendedRoles: [
      {
        title: "Accounts payable and receivable clerks",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Accounts clerks",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Arrears and debt recovery officers",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Audit assistants",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Audit support staff",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Bookkeepers",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Chief financial officer",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Client billing and accounts receivable",
        fit: "Challenging",
        description: "Challenging - niche or senior-only, higher oversight.",
        difficulty: 2,
        recommendedLocation: "India"
      },
      {
        title: "Financial analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "General accountants",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Management reporting analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Payroll and rostering support",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Tax preparation assistants",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Trust accountants",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Trust account administrators",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
    ]
  },
  {
    id: 3,
    flag: "🇮🇳",
    country: "India",
    city: "New Delhi",
    timezone: "GMT+5:30 (Indian Standard Time)",
    population: "1.4 billion",
    description: "India is the world's largest outsourcing destination with an enormous talent pool across all industries. The country excels in technology, engineering, and analytical roles, offering highly qualified professionals at competitive rates.",
    businessHours: "9:30 AM - 6:30 PM IST (Monday - Friday)",
    languages: "Hindi, English, 22+ regional languages",
    currency: "Indian Rupee (INR)",
    dialingCode: "+91",
    educationLevel: "Very High - World-class technical institutes (IITs, NITs)",
    internetSpeed: "Excellent - Advanced digital infrastructure in major cities",
    keyIndustries: [
      "Information Technology", 
      "Software Engineering", 
      "Data Science & Analytics",
      "+3"
    ],
    salaryRange: "$300 - $1,500 USD/month (varies greatly by role)",
    keyAdvantages: [
      "Largest talent pool globally across all skill levels",
      "Highly competitive pricing structure",
      "Strong project management capabilities",
      "Advanced digital infrastructure in tier-1 cities",
      "World-renowned technical education system",
      "Experience working with international clients",
      "24/7 work availability due to timezone",
      "Established legal framework for outsourcing"
    ],
    attributes: [
      "Highly ambitious and career-driven workforce",
      "Strong technical and analytical capabilities",
      "Excellent problem-solving skills",
      "Hierarchical workplace culture",
      "Value education and continuous learning",
      "Large diaspora provides cultural understanding of global markets",
    ],
    importantConsiderations: [
      "Accent can be noticeable in voice roles",
      "High attrition rates in some sectors",
      "Quality varies significantly - screening essential",
      "Cultural differences in communication style",
      "May require more structured management",
      "Time zone requires night shifts for US/AU alignment",
    ],
    recommendedRoles: [
      {
        title: "Accounts payable and receivable clerks",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Accounts clerks",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Arrears and debt recovery officers",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Audit assistants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Audit support staff",
        fit: "Viable",
        description: "Viable - works with training/process guardrails",
        difficulty: 3
      },
      {
        title: "Bookkeepers",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Chief financial officer",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Client billing and accounts receivable",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Financial analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "General accountants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Management reporting analysts",
        fit: "Strong fit",
        description: "Strong fit - very workable with light enablement",
        difficulty: 4
      },
      {
        title: "Payroll and rostering support",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Tax preparation assistants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Trust accountants",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
      {
        title: "Trust account administrators",
        fit: "Excellent fit",
        description: "Excellent fit - easy to hire, easy to run, low friction",
        difficulty: 5
      },
    ]
  }
];
